// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FractalsBase } from './FractalsBase';
export class FRACTALS5 extends FractalsBase {
    constructor() {
        super();
        this.initializeFractals('Fractals5', 5);
    }
    NextBar() {
        super.NextBar();
        this.processFractal(5);
    }
}
